import { Route, Switch, Redirect } from 'react-router-dom';
import { RouteTypes } from 'consts';
import Login from 'pages/Login';
import Home from 'pages/Home';
import Audit from 'pages/Audit';
import Create from 'pages/CreatePractice';
import Detail from 'pages/practiceDetail';
import AlumnosCurso from 'pages/AlumnosCurso';
import Courses from 'pages/Course';
import ReportCoursesClosing from 'pages/ReportCoursesClosing';
import Profile from 'pages/Profile';
import ReportHours from 'pages/ReportHours';
import ReportInfrastructure from 'pages/ReportInfrastructure';
import ValidationPhotos from 'pages/ValidationPhotos';
import PracticasAlumno from 'pages/AlumnosCurso/PracticasAlumno';
import ChangeFilter from 'pages/ChangeFilter';
import ReportInstructorHours from 'pages/ReportInstructorHours';
import PracticasInstructor from 'pages/ReportInstructorHours/PracticasInstructor';
import AltaAdministradores from 'pages/GestionUsuarios/AltaAdministradores/';
import AltaSupervisores from 'pages/GestionUsuarios/AltaSupervisores/';
import AltaVisualizadores from 'pages/GestionUsuarios/AltaVisualizadores/';
import AltaGestores from 'pages/GestionUsuarios/AltaGestores';
import AltaFormadores from 'pages/GestionUsuarios/AltaFormadores';
import AltaAlumnos from 'pages/GestionUsuarios/AltaAlumnos';
import CertificadosPracticas from 'pages/CertificadosPracticas';

// Las rutas comentadas pertenecen a la fase 2

const Routes = () => (
  <Switch>
    <Route exact path={RouteTypes.LOGIN} component={Login} />
    <Route exact path={RouteTypes.HOME} component={Home} />
    <Route exact path={RouteTypes.CHANGE_PROFILE} component={ChangeFilter} />
    <Route exact path={RouteTypes.CERTIFICADOS_PRACTICAS} component={CertificadosPracticas} />
    <Route
      exact
      path={RouteTypes.PRACTICES_ALUMN_COURSE}
      component={PracticasAlumno}
    />
    <Route exact path={RouteTypes.AUDIT} component={Audit} />
    <Route
      exact
      path={RouteTypes.VALIDATION_PHOTOS}
      component={ValidationPhotos}
    />
    <Route exact path={RouteTypes.CREATE} component={Create} />
    <Route exact path={RouteTypes.DETAIL} component={Detail} />
    {/* <Route exact path={RouteTypes.DETAIL_ALUMN_BYCOURSE} component={Detail} /> */}
    <Route exact path={RouteTypes.ALUMNS} component={AlumnosCurso} />
    <Route
      exact
      path={RouteTypes.PRACT_ALU_CURSO}
      component={PracticasAlumno}
    />
    <Route exact path={RouteTypes.COURSE} component={Courses} />
    <Route
      exact
      path={RouteTypes.REPORT_COURSES_CLOSING}
      component={ReportCoursesClosing}
    />
    <Route exact path={RouteTypes.PROFILE} component={Profile} />
    <Route exact path={RouteTypes.REPORT_HOURS} component={ReportHours} />
    <Route
      exact
      path={RouteTypes.REPORT_INFRAESTRUCTURE}
      component={ReportInfrastructure}
    />
    <Route
      exact
      path={RouteTypes.REPORT_HOURS_INSTRUCTOR}
      component={ReportInstructorHours}
    />
    <Route
      exact
      path={RouteTypes.PRACT_HOURS_INSTRUCTOR}
      component={PracticasInstructor}
    />
    <Route
      exact
      path={RouteTypes.ALTA_ADMINISTRADORES}
      component={AltaAdministradores}
    />
      <Route
      exact
      path={RouteTypes.ALTA_SUPERVISORES}
      component={AltaSupervisores}
    />
      <Route
      exact
      path={RouteTypes.ALTA_VISUALIZADORES}
      component={AltaVisualizadores}
    />
        <Route
      exact
      path={RouteTypes.ALTA_GESTORES}
      component={AltaGestores}
    />
        <Route
      exact
      path={RouteTypes.ALTA_FORMADORES}
      component={AltaFormadores}
    />
        <Route
      exact
      path={RouteTypes.ALTA_ALUMNOS}
      component={AltaAlumnos}
    />

    <Route path="**">
      <Redirect to={RouteTypes.LOGIN} />
    </Route>
  </Switch>
);

export default Routes;
